module.exports = __webpack_public_path__ + "static/media/galexy.5c2abce7.mp4";